<template>
  <div class="video-timeline">
    <div
      ref="sliderWidth"
      v-drag
      class="time-slider"
    >
      <div class="time-slider-rail"></div>
      <div
        class="time-slider-track"
        :style="{
          width: ((info.cr - info.cl) / info.max) * 100 + '%',
          left: (info.cl / info.max) * 100 + '%'
        }"
      ></div>
      <div
        class="time-slider-mask"
        data-action="click"
      ></div>
      <div
        data-action="handle"
        class="time-slider-handle"
        :style="{ left: ((info.val - info.min) / info.max) * 100 + '%' }"
      >
        <span></span>
      </div>
      <div
        class="time-slider-cl"
        :style="{ left: (info.cl / info.max) * 100 + '%' }"
      >
        <span v-show="action === 'cutLeft'">{{ info.cl | formatTime }}</span>
        <div data-action="cutLeft"></div>
      </div>
      <div
        class="time-slider-cr"
        :style="{ left: (info.cr / info.max) * 100 + '%' }"
      >
        <span v-show="action === 'cutRight'">{{ info.cr | formatTime }}</span>
        <div data-action="cutRight"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'VideoTimeline',
  directives: {
    drag(el, binding, vnode) {
      let _this = vnode.context,
        mousemove = null,
        mouseup = null,
        dataAction = '';

      mousemove = (e) => {
        _this.dragMove && _this.dragMove(e.pageX, dataAction, e);
      };

      mouseup = (e) => {
        document.removeEventListener('mousemove', mousemove);
        document.removeEventListener('mouseup', mouseup);

        _this.dragUp && _this.dragUp(e.pageX, dataAction, e);
      };

      el.onmousedown = (e) => {
        dataAction = e.target.dataset.action;

        if (e.which === 3 || e.which === 2) {
          e.stopPropagation();
          return;
        }

        document.addEventListener('mousemove', mousemove);
        document.addEventListener('mouseup', mouseup);

        _this.dragDown && _this.dragDown(e.pageX, dataAction, e);
      };
    }
  },
  filters: {
    formatTime(time) {
      let points = Math.round(time * 10) % 10;
      let minute = Math.floor(time / 60);
      let secound = Math.floor(time - minute * 60);
      function completion(val) {
        let s = val.toString();
        if (s.length === 0) {
          return '00';
        } else if (s.length === 1) {
          return '0' + s;
        } else {
          return s;
        }
      }
      return `${completion(minute)}:${completion(secound)}.${points}`;
    }
  },
  props: {
    info: {
      type: Object,
      required: true,
      limitLeft: 0,
      default: function() {
        return { step: 0.1, min: 0, max: 10, val: 0, cl: 0, cr: 10, maxl: 10 };
      }
    }
  },
  data() {
    return {
      width: 100,
      action: '',
      mpos: null
    };
  },
  methods: {
    dragDown(dis, action) {
      if (!action) return;
      this.width = this.$refs.sliderWidth.clientWidth;
      // todo --> 尺寸确定后可以修改下
      let val = 0,
        ll = 0,
        rl = this.info.max;
      if (action === 'click') {
        ll = this.info.cl;
        rl = this.info.cr
        ;({ left: this.limitLeft } = this.$refs.sliderWidth.getBoundingClientRect());
        let pre = Math.round((((dis - this.limitLeft) / this.width) * this.info.max) / this.info.step) / (1 / this.info.step);
        val = pre > rl ? rl : pre < ll ? ll : pre;
        this.$emit('changeData', { val: val, action: action, type: 'change' });
        return;
      } else if (action === 'handle') {
        ll = this.info.cl;
        rl = this.info.cr;
        val = this.info.val;
      } else if (action === 'cutRight') {
        ll = this.info.cl + 1;
        if (this.info.cl + this.info.maxl < rl) {
          rl = this.info.cl + this.info.maxl;
        }
        val = this.info.cr;
      } else if (action === 'cutLeft') {
        rl = this.info.cr - 1;
        if (this.info.cr - this.info.maxl > 0) {
          ll = this.info.cr - this.info.maxl;
        }
        val = this.info.cl;
      } else {
        return;
      }

      this.mpos = {
        x: dis,
        v: val,
        ll: ll,
        rl: rl
      };

      this.action = action;
      this.$emit('changeData', { val: val, action: action, type: 'start' });
    },
    dragMove(posx) {
      if (!this.action) return;
      let pre = Math.round((((posx - this.mpos.x) / this.width) * this.info.max + this.mpos.v) / this.info.step) / (1 / this.info.step),
        val = pre > this.mpos.rl ? this.mpos.rl : pre < this.mpos.ll ? this.mpos.ll : pre;
      this.$emit('changeData', { val: val, action: this.action, type: 'change' });
    },
    dragUp() {
      if (!this.action) return;
      this.mpos = null;
      this.$emit('changeData', { action: this.action, type: 'end' });
      this.action = '';
    }
  }
};
</script>
<style lang="scss" scoped>
.video-timeline {
  width: 100%;
  height: 50px;
}
.time-slider {
  position: relative;
  height: 50px;
  width: 100%;
  margin-right: 1px;
  -ms-touch-action: none;
  touch-action: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .time-slider-rail {
    position: absolute;
    width: 100%;
    background-color: #e0e2ea;
    height: 24px;
    border-radius: 4px;
  }

  .time-slider-track {
    position: absolute;
    background-color: #c1caf0;
    height: 24px;
    left: 0%;
    width: 69.1515%;
  }

  .time-slider-mask {
    position: absolute;
    width: 100%;
    height: 24px;
    left: 0;
    cursor: pointer;
    opacity: 0;
  }

  .time-slider-handle {
    position: absolute;
    margin-left: -6px;
    margin-top: 23px;
    left: 69.1515%;
    width: 13px;
    height: 19px;
    color: #ffffff;
    background: url('../../../public/img/svg/timeline-slider-handle.svg') no-repeat center;
    background-size: 140% 100%;
    cursor: -webkit-grab;
    cursor: grab;
    -ms-touch-action: pan-x;
    touch-action: pan-x;
    z-index: 50;

    span {
      position: absolute;
      border-left: 1px solid #2f58fe;
      height: 30px;
      top: -25px;
      left: 6px;
    }
  }

  .time-slider-cl,
  .time-slider-cr {
    position: absolute;
    width: 0;
    height: 0;

    div {
      position: absolute;
      top: 0;
      width: 11px;
      height: 24px;
      border: 3px solid #2f58fe;
      cursor: e-resize;
      box-sizing: border-box;
    }

    span {
      display: block;
      position: absolute;
      top: -20px;
      left: -24px;
      width: 48px;
      height: 10px;
      font-size: 12px;
    }
  }
  .time-slider-cl div {
    border-right: 0px;
    left: 0px;
  }
  .time-slider-cr div {
    left: -11px;
    border-left: 0px;
  }
}
</style>
